goog.provide("shadow.js.shim.module$dayjs$locale$uk");
goog.provide("module$shadow_js_shim_module$dayjs$locale$uk");
shadow.js.shim.module$dayjs$locale$uk = shadow.js.nativeProvides["dayjs/locale/uk"] = require("dayjs/locale/uk");
module$shadow_js_shim_module$dayjs$locale$uk.default = shadow.js.shim.module$dayjs$locale$uk;
